import React, { FunctionComponent, useEffect, useState, useRef } from 'react'
import ReactQuill from 'react-quill-new'
import { quillModules, getSemanticHtml } from 'Frontend/scripts/quillModules'
import { Button, Form } from 'react-bootstrap'
import { createForumPost } from 'Frontend/scripts/services/forums.service'
import { IAntiforgeryToken } from 'Frontend/scripts/models/general.model'
import { getAntiforgeryToken } from 'Frontend/scripts/services/general.service'
import { IUser } from 'Frontend/scripts/models/user.model'
import { getCurrentUser } from 'Frontend/scripts/services/users.service'
import { useTranslation } from 'react-i18next'

interface ThreadAnswerProps {
  forumThreadId: number
  callback: () => void | null
}

const ThreadCreateAnswer: FunctionComponent<ThreadAnswerProps> = ({ forumThreadId, callback }) => {
  const todaysDate = new Date().toJSON().slice(0, 10)
  const [validated, setValidated] = useState(false)
  const [answerText, setAnswerText] = useState('')
  const [hasValue, setHasValue] = useState<boolean>(false)
  const [submitted, setSubmitted] = useState<boolean>(false)
  const quillRef = useRef<ReactQuill | null>(null)
  const [user, setUser] = useState<IUser>()
  const { t } = useTranslation()

  const submitAnswer = (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault()
    setSubmitted(true)

    const form = evt.currentTarget
    if (form.checkValidity() === false || answerText.trim().length == 0 || answerText == null) {
      evt.preventDefault()
      evt.stopPropagation()
      setValidated(true)
    } else {
      const mainBodyWithCorrectHTML = getSemanticHtml(quillRef)
      getAntiforgeryToken().then((token: IAntiforgeryToken) => {
        createForumPost(token.csrfToken, forumThreadId, mainBodyWithCorrectHTML).then(() => {
          callback()
          setAnswerText('')
          setValidated(false)
        })
      })
    }
  }

  useEffect(() => {
    getCurrentUser().then((user) => {
      setUser(user)
    })
  }, [])

  useEffect(() => {
    answerText.length > 0 ? setHasValue(true) : setHasValue(false)
  }, [answerText])
  return (
    <>
      <div className="livstecknet-thread__answer-area mt-3 p-3">
        <div className="d-flex gap-2 mb-3">
          {user?.profileImageUrl != null ? (
            <div>
              <img
                className="workrooms__profile-image"
                src={user.profileImageUrl}
                alt={`${t('image-of')} ${user?.firstname} ${user?.lastname}`}
              />
            </div>
          ) : (
            <div className="livstecknet-thread__profile-initial-letters">
              {user?.firstname.charAt(0)}
              {user?.lastname.charAt(0)}
            </div>
          )}
          <div className="d-flex flex-column justify-content-center">
            <a href={user?.viewProfileUrl} className="livstecknet-thread__author">
              {user?.firstname}&nbsp;
              {user?.lastname}
            </a>
            <p className="livstecknet-thread__time mb-0">{todaysDate}</p>
          </div>
        </div>
        <Form noValidate validated={validated} onSubmit={submitAnswer} className="d-flex flex-column gap-3">
          <Form.Group>
            <ReactQuill
              ref={quillRef}
              id="inputThreadMainBody"
              className="notice__quill-editor"
              theme="snow"
              modules={quillModules}
              value={answerText}
              onChange={setAnswerText}
            />
            {submitted && !hasValue && <span className="invalid-feedback d-block">{t('error-message-answer')}</span>}
          </Form.Group>

          <div className="d-flex gap-3">
            <Button variant="secondary" type="submit">
              {t('answer-on-post')}
            </Button>
          </div>
        </Form>
      </div>
    </>
  )
}

export default ThreadCreateAnswer
